import flattenDeep from 'lodash/flattenDeep';

const castArray = (...args) => flattenDeep(Array.of(...args));

export { castArray as default };
